import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import TeamLogo from "./TeamLogo";

export default function TeamCard({ team, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.45, delay: index * 0.05, ease: [0.16, 1, 0.3, 1] }}
      whileHover={{ y: -4 }}
      data-testid={`team-card-${team.slug}`}
      className="group relative overflow-hidden bg-pshl-surface border border-white/8 hover:border-pshl-electric transition-colors"
    >
      <div
        className="absolute -top-12 -right-10 h-48 w-48 rounded-full blur-3xl opacity-30 group-hover:opacity-60 transition-opacity"
        style={{ background: team.primary }}
      />
      <div className="relative p-6 flex flex-col gap-5">
        <div className="flex items-start justify-between">
          <div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-white/55">{team.state}</div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-pshl-electric font-mono mt-1">{team.abbr}</div>
          </div>
          <TeamLogo team={team} size={88} />
        </div>

        <div>
          <h3 className="font-display text-2xl text-white leading-tight">{team.name}</h3>
          <p className="mt-2 text-sm text-white/70 leading-relaxed">{team.tagline}</p>
        </div>

        <div className="flex items-center justify-between pt-3 border-t border-white/10">
          <span className="text-xs uppercase tracking-[0.2em] text-white/55">{team.city}</span>
          <Link
            to={`/teams/${team.slug}`}
            data-testid={`view-team-${team.slug}`}
            className="inline-flex items-center gap-1 text-xs font-display uppercase tracking-[0.18em] text-white group-hover:text-pshl-electric transition-colors"
          >
            View Team <ArrowUpRight className="h-3.5 w-3.5" />
          </Link>
        </div>
      </div>
    </motion.div>
  );
}
